module.exports = __webpack_public_path__ + "static/media/download.04b3f5b0.svg";